module.exports = __webpack_public_path__ + "static/media/seguradora_azul.d11a9e4c.png";